import { SKTButton } from "../../components/SKTButton";
import { SKTToolbar } from "../../components/SKTToolbar";
import { useState } from "react";
import { SKTToggle } from "../../components/SKTToggle";
import { OrderList } from "./OrderList";
import { AccountInfo } from "./AccountInfo";
import { ChangePasswordForm } from "./ChangePassword";
import { css } from "../../components/SKT";

const TabButton = ({ tab, label }) => {
  const [currentTab, setTab] = tab;
  const type = currentTab === label ? "btn-primary" : "";

  const change = () => {
    setTab(label);
  };

  return <SKTButton label={label} type={type} onClick={change} />;
};

export const UserProfile = ({ auth, doLogout }) => {
  const tab = useState("Asiakastili");
  const currentTab = tab[0];

  const doOrder = () => {
    if (auth.is_corporate) {
      window.location.href = "/tavarakuljetukset-yritykset";
    } else {
      window.location.href = "/tavarakuljetukset/";
    }
  };

  return (
    <div className={css("front-block container col-lg-12")}>
      <SKTToolbar>
        <SKTButton type="btn-success" label="Uusi tilaus" onClick={doOrder} />
        <TabButton tab={tab} label="Asiakastili" />
        <TabButton tab={tab} label="Tilaukset" />

        <TabButton tab={tab} label="Vaihda salasana" />

        <SKTButton
          type="btn-warning"
          label="Kirjaudu ulos"
          onClick={doLogout}
        />
      </SKTToolbar>
      <SKTToggle when={currentTab === "Asiakastili"}>
        <AccountInfo />
      </SKTToggle>
      <SKTToggle when={currentTab === "Tilaukset"}>
        <OrderList />
      </SKTToggle>
      <SKTToggle when={currentTab === "Osoitekirja"}>
        <div>Osoitekirja tähän!</div>
      </SKTToggle>
      <SKTToggle when={currentTab === "Vaihda salasana"}>
        <ChangePasswordForm doLogout={doLogout} />
      </SKTToggle>
    </div>
  );
};
